/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/******* QUICK LINKS SECTION: SIZING LIGHTBOX FUNCTIONALITY *******/
document.addEventListener("DOMContentLoaded", function () {
  // Use event delegation to safely support multiple sections and dynamic content
  document.body.addEventListener("click", function (e) {
    const trigger = e.target.closest(".js-lightbox-trigger");

    if (trigger) {
      e.preventDefault();

      const popupId = trigger.getAttribute("data-popup-id");
      const contentDiv = document.getElementById(popupId);

      if (contentDiv) {
        showLightbox(contentDiv.innerHTML);
      }
    }
  });

  function showLightbox(content) {
    // Prevent duplicate modals
    if (document.querySelector(".lightbox-overlay")) return;

    const modal = document.createElement("div");
    modal.className = "lightbox-overlay";
    modal.innerHTML = `
      <div class="lightbox-content">
        <button class="lightbox-close" aria-label="Close popup">&times;</button>
        <div class="lightbox-body">${content}</div>
      </div>
    `;

    document.body.appendChild(modal);

    // Close logic
    modal.querySelector(".lightbox-close").addEventListener("click", () => modal.remove());
    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.remove();
    });

    // Optional: lock scroll
    document.body.style.overflow = "hidden";

    // Cleanup scroll lock on removal
    const observer = new MutationObserver(() => {
      if (!document.body.contains(modal)) {
        document.body.style.overflow = "";
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true });
  }
});

